export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "webp.worker.c0cc94110cda650246b2.bundle.worker.js");
}
